import compose from 'lodash/flowRight';

import { crateFrameConfigModule } from '@xingternal/crate-communication-frame-config-module';
import { reachLinkModule } from '@xingternal/crate-communication-reach-link-module';
import { featureSwitchesModule } from '@xingternal/feature-switches-module';
import { initialDataModule } from '@xingternal/initial-data-module';
import { splitkitHubModule } from '@xingternal/splitkit';
import { themingModule } from '@xingternal/theming-module';
import {
  XingFrameProvider,
  withApolloClient,
  withHub,
  withStaticDataOnly,
} from '@xingternal/xing-frame-provider';
import navigationData from '@xingternal/xing-frame-provider/data/navigation';
import { withHubData } from '@xingternal/xing-frame-provider/lib/withHubData';

const withLoggedInContexts: (component: typeof XingFrameProvider) => React.FC<{
  activeItem?: string | null;
  internalPaths: string[];
  isWillingnessToChangeJobsUsed?: boolean;
  userConsentSettings: { disableBanner: boolean };
}> = compose(
  withStaticDataOnly({ navigationData }),
  withApolloClient,
  withHub([
    initialDataModule,
    featureSwitchesModule,
    themingModule,
    reachLinkModule,
    splitkitHubModule,
    crateFrameConfigModule,
  ]),
  withHubData
);

// using XingFrameProvider here and nowhere else in Crate, please.
export const LoggedInFrameProvider = withLoggedInContexts(XingFrameProvider);

const withLoggedOutContexts: (component: typeof XingFrameProvider) => React.FC<{
  internalPaths: string[];
  userConsentSettings: { disableBanner: boolean };
}> = compose(
  withStaticDataOnly({ navigationData }),
  withApolloClient,
  withHub([
    themingModule,
    reachLinkModule,
    splitkitHubModule,
    crateFrameConfigModule,
  ])
);

export const LoggedOutFrameProvider = withLoggedOutContexts(XingFrameProvider);
